import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_BASE_URL;

export const register = async (userData) => {
    return axios.post(`${API_URL}/auth/register`, userData, { withCredentials: true });
};

export const login = async (userData) => {
    console.log(API_URL)
    return axios.post(`${API_URL}/auth/login`, userData, { withCredentials: true });
};

export const refreshToken = async () => {
    return axios.post(`${API_URL}/auth/refresh-token`, {}, { withCredentials: true });
};

export const logout = async () => {
    return axios.post(`${API_URL}/auth/logout`, {}, { withCredentials: true });
};
